import React, { Fragment } from 'react'
import * as R from 'ramda'
import Link from 'gatsby-link'
import classname from 'classnames'
import PropTypes from 'prop-types'
import { constructPageLink } from '@helpers/LinkHelper'
import 'lazysizes'
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import { ReactComponent as RightArrow } from '@assets/svgs/icons/keyboard-right-arrow-button.svg'
import './SearchResultBlock.module.scss'

const renderLink = (type, title, image, branchPhone) => (
  <Fragment>
    {R.equals(type, 'product') && (
      <div styleName='result-product-image'>
        <img alt='search result product image' data-src={image} className='lazyload' />
      </div>
    )}
    <div
      styleName={classname({
        'result-page': R.equals(type, 'page'),
        'result-product': R.equals(type, 'product')
      })}
    >
      <p styleName='title-link'>
        {branchPhone ? `${title}, Tel: ${branchPhone}` : title}
      </p>
    </div>
    <RightArrow styleName='right-arrow' />
  </Fragment>
)

const SearchResultBlock = ({ slug, category, templateType, brochure, id, type, title, image, branchPhone, onClick }) => (
  <Fragment>
    {brochure ? (
      <a styleName='result-block-wrapper' href={brochure}>
        {renderLink(type, title, image, branchPhone)}
      </a>
    ) : (
      <Link
        to={constructPageLink(slug, templateType, category, id)}
        styleName='result-block-wrapper'
        onClick={onClick}
      >
        {renderLink(type, title, image, branchPhone)}
      </Link>
    )}
  </Fragment>
)

export default SearchResultBlock

SearchResultBlock.propTypes = {
  title: PropTypes.string,
  slug: PropTypes.string,
  image: PropTypes.string,
  category: PropTypes.string,
  descrioption: PropTypes.string,
  templateType: PropTypes.string,
  branchPhone: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/ModalSearch/SearchResultBlock/SearchResultBlock.js